<div class="container">
  <div class="row g-3 ">
  <div class="col-lg-8">
    <!-- Trip Header Card -->
    <div class="card-soft mb-3" style="border-top: 4px solid #f97415;border-radius: 12px;">
      <div class="d-flex justify-content-between flex-wrap" style="border-bottom: 1px solid oklch(0.97 0.01 0); margin-bottom: 15px;">
        <div class="mb-2">
        <span class="badge rounded-circle p-1 me-1" style="background-color: #FF6B35; width: 8px; height: 8px;"></span>
        <span class="fw-semibold small" style="color: #FF6B35;text-transform: uppercase;">Pickup & Drop</span>
      </div>
      <div class="small text-muted mb-3">
        <i class="fa-solid fa-calendar" style="color:#999494e0"></i> &nbsp;
        {{ formatBookingDate(booking.date) || '' }} | {{ booking.time || '' }}
      </div>
      </div>

      <div class="mb-3">
  <div>
    <span class="badge rounded-circle p-1"></span>
    <span class="fw-bold d-flex"><i class="bi bi-dot icon-specific" style="color: #00c951;"></i> {{ booking.pickup.name || 'Mumbai' }}</span>
  </div>

  <div class="d-flex align-items-center gap-2 mt-2">
    <span class="fw-bold d-flex"><i class="bi bi-dot icon-specific" style="color: #fb2c36;"></i>{{ booking.dropoff.name || '' }}</span>
  </div>
</div>


      <div class="d-flex align-items-center justify-content-between pt-3 flex-wrap" style="border-top: 1px solid oklch(0.97 0.01 0);">
        <div>
         <h5 class="fw-bold">{{ booking.vehicle?.name || 'Indica Swift' }}</h5>
        <div class="d-flex gap-2 mb-3">
          <div class="px-3 py-2 rounded-3" style="border: 1px solid #FFD4C0; background-color: #ffedd4; border-radius: 3.40282e38px !important;">
            <span class="fw-medium" style="color: #ca3500;font-size: 0.8rem;">
              {{ (booking.passengers?.adults || 0) < 10 ? '0' + (booking.passengers?.adults || 0) : (booking.passengers?.adults || 0) }} Adults,
              {{ (booking.passengers?.children || 0) < 10 ? '0' + (booking.passengers?.children || 0) : (booking.passengers?.children || 0) }} Children
            </span>
          </div>
          <div class="px-3 py-2 rounded-3" style="border: 1px solid #FFD4C0; background-color: #ffedd4; border-radius: 3.40282e38px !important;">
            <span class="fw-medium" style="color: #ca3500;font-size: 0.8rem;">
              {{ (booking.passengers?.luggage || 0) < 10 ? '0' + (booking.passengers?.luggage || 0) : (booking.passengers?.luggage || 0) }} Luggages
            </span>
          </div>
        </div>
        </div>

        <div class="d-flex align-items-center gap-3 text-muted small">
          <span>
            <i class="bi bi-people-fill me-1" style="color:#999494e0"></i>
            {{ vehicleOne?.seats || 4 }} seats
          </span>
          <span>
            <i class="bi bi-bag-fill me-1" style="color:#999494e0"></i>
            {{ vehicleOne?.bags || 2 }} Bags
          </span>
        </div>
      </div>
    </div>



    <!-- Traveller Details -->
    <div class="card-soft mb-3" id="travellerSection">
  <h6 class="fw-bold mb-3">Traveller Details</h6>
  <div class="row g-3">

    <!-- First Name -->
    <div class="col-6 col-md-6" id="firstNameField">
      <label class="form-label small text-muted mb-1">First Name</label>
      <input class="form-control"
             name="firstName"
             [(ngModel)]="booking.traveller.firstName"
             #firstName="ngModel"
             required
             placeholder="First Name"
             style="border-radius: 8px;">

      <small class="text-danger" *ngIf="firstName.invalid && firstName.touched">
        First name is required and must contain only letters.
      </small>
    </div>

    <!-- Last Name -->
    <div class="col-6 col-md-6" id="lastNameField">
      <label class="form-label small text-muted mb-1">Last Name</label>
      <input class="form-control"
             name="lastName"
             [(ngModel)]="booking.traveller.lastName"
             #lastName="ngModel"
             required
             pattern="^[A-Za-z]+$"
             placeholder="Last Name"
             style="border-radius: 8px;">

      <small class="text-danger" *ngIf="lastName.invalid && lastName.touched">
        Last name is required and must contain only letters.
      </small>
    </div>

    <!-- Mobile -->
    <div class="col-md-6" id="mobileField">
      <label class="form-label small text-muted mb-1">Mobile Number</label>
      <input class="form-control"
             name="mobile"
             [(ngModel)]="booking.traveller.mobile"
             #mobile="ngModel"
             required
             pattern="^[6-9][0-9]{9}$"
             maxlength="10"
             (blur)="onMobileBlur()"
             placeholder="Mobile Number"
             style="border-radius: 8px;">

      <small class="text-danger" *ngIf="mobile.invalid && mobile.touched">
        Enter a valid 10-digit mobile number.
      </small>
    </div>

<!-- Email -->
	<div class="col-md-6">
	  <label class="form-label small text-muted mb-1">Email Address</label>
	  <input class="form-control"
	         name="email"
	         [(ngModel)]="booking.traveller.email"
	         #email="ngModel"
	         placeholder="Email Address"
         style="border-radius: 8px;">
</div>

    <!-- Special Notes -->
    <div class="col-12">
      <label class="form-label small text-muted mb-1">Special Notes</label>
      <textarea class="form-control"
                name="notes"
                [(ngModel)]="booking.traveller.notes"
                #notes="ngModel"
                rows="3"
                placeholder="Add any special instructions or notes..."
                style="border-radius: 8px; resize: none;"></textarea>
    </div>

  </div>
</div>



  </div>
  <div class="col-lg-4">
    <!-- Estimated Journey Cost -->
    <div class="card-soft mb-3" style="background-color: #f8fafc !important;">
      <h6 class="fw-bold mb-3" style="color: #FF6B35;">Estimated Journey Cost</h6>

  <ng-container *ngIf="booking?.fareQuote as fare">

  <!-- ================= PICKUP & DROP ================= -->
  <ng-container *ngIf="fare.tripType === 'pickup_drop'">

    <div class="d-flex justify-content-between mb-2">
      <div class="text-dark small">
        Base Fare
        <small class="text-muted">(Includes base km)</small>
      </div>
      <div class="fw-bold">
        ₹{{ fare.lines[0]?.amount | number:'1.0-2' }}
      </div>
    </div>

    <div
      class="d-flex justify-content-between mb-2"
      *ngFor="let line of fare.lines"
      [hidden]="line.code !== 'EXTRA_KM'"
    >
      <div class="text-dark small" [hidden]="line.code !== 'EXTRA_KM'">
        Extra Distance
        <small class="text-muted">
          ({{ line.qty | number:'1.2-2' }} km × ₹{{ line.unitPrice }})
        </small>
      </div>
      <div class="fw-bold" [hidden]="line.code !== 'EXTRA_KM'">
        ₹{{ line.amount | number:'1.0-2' }}
      </div>
    </div>

  </ng-container>

  <!-- ================= RENTAL ================= -->
  <ng-container *ngIf="fare.tripType === 'rental'">

    <div
      class="d-flex justify-content-between mb-2"
      *ngFor="let line of fare.lines"
    >
      <div class="text-dark small">
        {{ line.label }}
        <small class="text-muted" *ngIf="line.code !== 'PACKAGE'">
          ({{ line.qty | number:'1.2-2' }} × ₹{{ line.unitPrice }})
        </small>
      </div>
      <div class="fw-bold">
        ₹{{ line.amount | number:'1.0-2' }}
      </div>
    </div>

  </ng-container>

  <!-- ================= OUTSTATION ================= -->
  <ng-container *ngIf="fare.tripType === 'outstation'">

    <div class="mb-2 text-muted small">
      Minimum distance per day rule applies
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="text-dark small">Actual Distance</div>
      <div class="fw-bold">
        {{ fare.distanceKm | number:'1.2-2' }} km
      </div>
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="text-dark small">
        Billable Distance
        <small class="text-muted">
          (Higher of actual distance <br/> or minimum per-day distance)
        </small>
      </div>
      <div class="fw-bold">
        {{ fare.lines[0]?.qty | number:'1.2-2' }} km
      </div>
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="text-dark small">
        Distance Charge
        <small class="text-muted">
          ({{ fare.lines[0]?.qty | number:'1.2-2' }} km × ₹{{ fare.lines[0]?.unitPrice }})
        </small>
      </div>
      <div class="fw-bold">
        ₹{{ fare.lines[0]?.amount | number:'1.0-2' }}
      </div>
    </div>

    <div class="d-flex justify-content-between mb-2">
      <div class="text-dark small">
        Driver Allowance
        <small class="text-muted">
          ({{ fare.lines[1]?.qty }} day × ₹{{ fare.lines[1]?.unitPrice }})
        </small>
      </div>
      <div class="fw-bold">
        ₹{{ fare.lines[1]?.amount | number:'1.0-2' }}
      </div>
    </div>

  </ng-container>

  <hr class="my-3">
    <div
    class="d-flex justify-content-between mb-2"
    *ngIf="booking?.pricing?.baseAmount"
  >
    <div class="text-dark small">
      Sub Total:
    </div>
    <div class="fw-bold">
      ₹{{ booking?.pricing?.baseAmount | number:'1.0-2' }}
    </div>
  </div>
  <!-- ================= TAX (DISPLAY ONLY) ================= -->
  <div
    class="d-flex justify-content-between mb-2"
    *ngIf="booking?.pricing?.taxPercentage && booking?.pricing?.taxAmount"
  >
    <div class="text-dark small">
      GST ({{ booking.pricing.taxPercentage }}%)
    </div>
    <div class="fw-bold">
      ₹{{ booking.pricing.taxAmount | number:'1.0-2' }}
    </div>
  </div>

  <!-- ================= TOTAL ================= -->
  <div class="d-flex justify-content-between align-items-center" *ngIf="booking.pricing.totalAmount" >
    <div class="fw-bold">Total Estimated Fare</div>
    <div class="fw-bold fs-6">
      ₹{{ booking.pricing.totalAmount | number:'1.0-2' }}
    </div>
  </div>

  <!-- ================= NOTES ================= -->
  <div class="mt-3" *ngIf="fare.notes?.length">
    <small class="text-muted d-block mb-1">Note:</small>
    <ul class="small text-muted ps-3 mb-0">
      <li *ngFor="let note of fare.notes">{{ note }}</li>
    </ul>
  </div>

  </ng-container>

<hr class="my-3">
  <div *ngIf="inclusions && inclusions.length > 0; else noInclusions">
  <h6 class="fw-bold mb-3" style="color: #FF6B35;">Inclusions</h6>

  <ul class="list-unstyled mb-0">
    <li class="mb-3" *ngFor="let item of inclusions; let last = last">
      <div class="d-flex align-items-start gap-2">
        <span
          class="badge rounded-circle mt-1"
          [ngClass]="last ? 'bg-danger' : 'bg-secondary'"
          style="width: 6px; height: 6px; padding: 3px;">
        </span>

        <div class="flex-grow-1">
          <div class="fw-semibold small text-dark">
            {{ item?.title }}
          </div>
          <div class="text-muted" style="font-size: 0.75rem;">
            {{ item?.subtitle }}
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>

<!-- Debug fallback (remove later if not needed) -->
<ng-template #noInclusions>
  <div class="small text-muted">
    Inclusions not available.
  </div>
</ng-template>


    </div>

  </div>
      <!-- Action Buttons -->
    <div class="d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-secondary d-flex align-items-center gap-2 px-4 py-2 goBack" (click)="goBack()" style="border-radius: 8px;">
        <i class="bi bi-arrow-left"></i>
        <span>Go back</span>
      </button>
      <button
        class="btn btn-dark px-5 py-2 forwardMove"
        [disabled]="isConfirming || isCheckingCustomer || firstName.invalid || lastName.invalid || mobile.invalid"
        (click)="confirm(firstName, lastName, mobile)"
        style="border-radius: 8px;"
      >
        <ng-container *ngIf="isCheckingCustomer">
          <span class="spinner-border spinner-border-sm me-2"></span>
          Verifying...
        </ng-container>

        <ng-container *ngIf="!isCheckingCustomer && !isConfirming">
          Confirm Booking
        </ng-container>

        <ng-container *ngIf="isConfirming">
          <span class="spinner-border spinner-border-sm me-2"></span>
          Confirming your booking…
        </ng-container>
      </button>

    </div>
</div>
</div>

